import React from "react";
import threeEasySteps from "assets/products/mlta/three-easy-steps.webp";

interface ThreeEasyStepsProps {
    className?: string;
}

const ThreeEasySteps = ({ className = "" }: ThreeEasyStepsProps) => {
    return (
        <div className={`flex flex-col tablet:relative w-full overflow-hidden tablet:h-[648px] ${className}`}>
            <img
                src={threeEasySteps}
                alt="Three Easy Steps background"
                className="w-full h-[300px] tablet:absolute tablet:inset-0 tablet:h-full object-cover -scale-x-100"
            />
            {/* Content wrapper with max-width */}
            <div className="w-full max-w-[1200px] mx-auto tablet:absolute tablet:inset-0 tablet:flex tablet:items-center">
                <div className="relative w-full tablet:bg-accent bg-base-content tablet:w-fit flex items-center h-auto tablet:rounded-tr-3xl tablet:rounded-br-3xl tablet:rounded-tl-none tablet:rounded-bl-none large:rounded-tl-3xl large:rounded-bl-3xl rounded-2xl py-5 px-4 tablet:py-6 tablet:px-6 mt-[-2rem] tablet:mt-0 z-10 tablet:before:content-[''] tablet:before:absolute tablet:before:inset-y-0 tablet:before:right-full tablet:before:left-[-100vw] tablet:before:bg-accent large:before:content-none">
                    <div className="max-w-full w-full tablet:max-w-[540px]">
                        <div className="text-primary-content h-full tablet:text-5xl text-3xl tablet:font-normal font-semibold tablet:leading-none leading-9 font-sans text-center tablet:text-left">
                            Three easy steps
                        </div>
                        <div className="space-y-6 py-6">
                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <span className="text-white font-bold text-4xl tablet:text-3xl">1</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-white mb-2">Choose your coverage</h3>
                                    <p className="text-white">
                                        Enter your information at the top of this page to see your quote.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <span className="text-white font-bold text-4xl tablet:text-3xl">2</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-white mb-2">Complete our simplified form</h3>
                                    <p className="text-white">
                                        No medical questions required. It only takes a few minutes to enter your contact
                                        information and beneficiary details and accept this offer.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <span className="text-white font-bold text-4xl tablet:text-3xl">3</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-white mb-2">Enjoy immediate protection</h3>
                                    <p className="text-white">
                                        As a AAA member, your acceptance is guaranteed. Your coverage will be immediately
                                        available once complete – it's that easy!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThreeEasySteps;
